import { post, put } from '../Services/http'
import { catchError } from './Error.action'
import { toast } from 'react-toastify'
import { translate } from '../Services/translation'
import { isNullOrWhiteSpace } from '../Services/strings'

const rootRoute = '/api/tirehotel'

export const TIREHOTEL_RECEIVE = 'TIREHOTEL_RECEIVE'
export const TIREHOTEL_ERROR = 'TIREHOTEL_ERROR'
export const TIREHOTEL_HANDLE_CUSTOMER_CHANGE =
    'TIREHOTEL_HANDLE_CUSTOMER_CHANGE'
export const TIREHOTEL_HANDLE_TIRESET_CHANGE = 'TIREHOTEL_HANDLE_TIRESET_CHANGE'
export const TIREHOTEL_HANDLE_TIRE_CHANGE = 'TIREHOTEL_HANDLE_TIRE_CHANGE'

export const saveTireSet =
    (tireSet, sendConfirmation, sendConfirmationRedirectUrl) => (dispatch) =>
        put(rootRoute + '/SaveTireSet/' + sendConfirmation, tireSet)
            .then((response) => response.json())
            .then((tireHotel) => {
                dispatch(receive(tireHotel))
                if (sendConfirmation && sendConfirmation == true) {
                    toast.success(
                        translate(
                            'tirehotel.successmessage.savetiresetandsendconfirmation'
                        ),
                        {
                            onClose: () =>
                                !isNullOrWhiteSpace(sendConfirmationRedirectUrl)
                                    ? (window.location =
                                          sendConfirmationRedirectUrl)
                                    : '',
                        }
                    )
                } else {
                    toast.success(
                        translate('tirehotel.successmessage.savetireset')
                    )
                }
            })
            .catch((ex) =>
                dispatch(catchError(ex, (error) => loadError(error)))
            )

export const saveTireSetAndPrintSticker =
    (tireSet, printStickerUrl) => (dispatch) =>
        put(rootRoute + '/SaveTireSet/false', tireSet)
            .then((response) => response.json())
            .then((tireHotel) => {
                dispatch(receive(tireHotel))
                window.open(printStickerUrl, '_blank')
                toast.success(
                    translate(
                        'tirehotel.successmessage.savetiresetandprintlabel'
                    )
                )
            })
            .catch((ex) =>
                dispatch(catchError(ex, (error) => loadError(error)))
            )

export const deleteTire = (tireSet) => (dispatch) =>
    put(rootRoute + '/DeleteTire', tireSet)
        .then((response) => response.json())
        .then((tireHotel) => {
            dispatch(receive(tireHotel))
            toast.success(translate('tirehotel.successmessage.deletetire'))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))

export const addTire = (tireSet) => (dispatch) =>
    put(rootRoute + '/AddTire', tireSet)
        .then((response) => response.json())
        .then((tireHotel) => {
            dispatch(receive(tireHotel))
            toast.success(translate('tirehotel.successmessage.addtire'))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))

export const deleteTireSet = (tireSet) => (dispatch) =>
    post(rootRoute + '/DeleteTireSet', tireSet)
        .then((response) => response.json())
        .then((tireHotel) => {
            dispatch(receive(tireHotel))
            toast.success(translate('tirehotel.successmessage.deletetireset'))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))

export const addTireSet = () => (dispatch, getState) => {
    const { payload } = getState().tireHotel
    post(rootRoute + '/AddTireSet', payload.customer)
        .then((response) => response.json())
        .then((tireHotel) => {
            dispatch(receive(tireHotel))
            toast.success(translate('tirehotel.successmessage.addtireset'))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const disableCustomer = (customerId) => (dispatch, getState) => {
    post(rootRoute + '/disableCustomer?systemId=' + customerId)
        .then((response) => response.json())
        .then((json) => {
            dispatch(receive(json))
            toast.success("Disabled customer");
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const enableCustomer = (customerId) => (dispatch, getState) => {
    const { payload } = getState().tireHotel;
    post(rootRoute + '/enableCustomer?systemId=' + customerId)
        .then((response) => response.json())
        .then((json) => {
            dispatch(receive(json))
            toast.success("Enabled customer");
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}


export const saveOrder = (order, sendConfirmation = false) => (dispatch) => {
    post(rootRoute + `/saveOrder/${sendConfirmation}`, order)
        .then((response) => response.json())
        .then((tireHotel) => {
            dispatch(receive(tireHotel))
            toast.success(translate('tirehotel.successmessage.saveOrder'))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const cancelTireHotel = (tireSets) => (dispatch) => {
    post(rootRoute + '/CancelTireHotel', tireSets)
        .then((response) => response.json())
        .then((tireHotel) => {
            dispatch(receive(tireHotel))
            toast.success(translate('tirehotel.successmessage.canceltirehotel'))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const saveTireHotelCustomer =
    (accordionRef, accordionIndex) => (dispatch, getState) => {
        const { payload } = getState().tireHotel
        post(rootRoute + '/CreateOrUpdateCustomer', payload.customer)
            .then((response) => response.json())
            .then((tireHotel) => {
                dispatch(
                    handleCustomerChange(
                        'systemId',
                        tireHotel.customer.systemId
                    )
                )
                dispatch(receive(tireHotel))
                dispatch(handleCustomerChange('isDirty', false))
                toast.success(
                    translate('tirehotel.successmessage.savetirehotelcustomer')
                )
                if (accordionRef) {
                    accordionRef.setState({
                        index: accordionIndex ? accordionIndex : -1,
                    })
                }
            })
            .catch((ex) => {
                dispatch(catchError(ex, (error) => loadError(error)))
            })
    }

export const saveTireSetAndUploadImage =
    (tireSet, image, tireSetPersonSystemId) => (dispatch) => {
        put(rootRoute + '/SaveTireSet/false', tireSet)
            .then((response) => response.json())
            .then((tireHotel) => {
                dispatch(receive(tireHotel))
                toast.success(translate('tirehotel.successmessage.savetireset'))

                var formData = new FormData()

                for (var i = 0; i < image.length; i++) {
                    formData.append('photo' + i, image[i])
                }

                formData.append('tireSetId', tireSet.id)
                formData.append('tireSetPersonSystemId', tireSetPersonSystemId)

                let options = {
                    method: 'POST',
                    headers: {
                        'litium-request-context': JSON.stringify(
                            window.__litium.requestContext
                        ),
                    },
                    credentials: 'include',
                }

                const token = window.localStorage.getItem(
                    'requestVerificationToken'
                )
                if (token) {
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            RequestVerificationToken: token,
                        },
                    }
                }

                fetch(rootRoute + '/UploadImage', {
                    ...options,
                    body: formData,
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw response
                        }
                        return response.json()
                    })
                    .then((tireHotel) => {
                        dispatch(receive(tireHotel))
                        toast.success(translate('tirehotel.image.uploaded'))
                    })
                    .catch((ex) => ex.json())
                    .then((ex) =>
                        dispatch(catchError(ex, (error) => loadError(error)))
                    )
            })
            .catch((ex) =>
                dispatch(catchError(ex, (error) => loadError(error)))
            )
    }

export const deleteImage = (image) => (dispatch) => {
    post(rootRoute + '/DeleteImage', {
        Id: image.id,
        TireSetId: image.tireSetId,
        BlobUri: image.blobUri,
    })
        .then((response) => response.json())
        .then((tireHotel) => {
            dispatch(receive(tireHotel))
            toast.success(translate('tirehotel.successmessage.deleteimage'))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const handleCustomerChange = (propName, value) => ({
    type: TIREHOTEL_HANDLE_CUSTOMER_CHANGE,
    payload: {
        key: 'customer',
        data: {
            [propName]: value,
        },
    },
})

export const handleTireSetInputChange = (propName, value, index) => ({
    type: TIREHOTEL_HANDLE_TIRESET_CHANGE,
    payload: {
        key: 'tireSets',
        data: {
            [propName]: value,
        },
        index: index,
    },
})

export const handleTireInputChange = (
    propName,
    value,
    tireSetIndex,
    index
) => ({
    type: TIREHOTEL_HANDLE_TIRE_CHANGE,
    payload: {
        key: 'tireSets',
        data: {
            [propName]: value,
        },
        tireSetIndex: tireSetIndex,
        index: index,
    },
})

export const receive = (tireHotel) => ({
    type: TIREHOTEL_RECEIVE,
    payload: {
        payload: tireHotel,
        errors: [],
    },
})

export const loadError = (error) => ({
    type: TIREHOTEL_ERROR,
    payload: {
        error,
    },
})
